module.exports = __webpack_public_path__ + "img/login_background.d92d0699.jpg";